module.exports = __webpack_public_path__ + "static/media/OFF.fa620260.svg";